import * as React from 'react';
import type { SVGProps } from 'react';

const SvgForumIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#222426" d="M0 0v20h16l4-4V0H0Zm19 15h-4v3.999H1.001v-15h18L19 15Z" />
    <path fill="#222426" d="M3 7h14v1H3V7ZM3 11h14v1H3v-1ZM3 14.999h10v1H3v-1Z" />
  </svg>
);
export default SvgForumIcon;
